// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleOutlinedSvg from "@fishx/icons-svg/es/asn/MinusCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleOutlinedSvg
  }));
};

MinusCircleOutlined.displayName = 'MinusCircleOutlined';
export default React.forwardRef(MinusCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusCircleOutlined.js
// module id = 3140
// module chunks = 0